import React from 'react';
import { useState, useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { Collapse } from 'react-bootstrap';
import { ApiProvider } from '../../providers/apiProvider';
import {useTranslation} from 'react-i18next';
import CertificateField from '../formElements/certificateField';
import { useFormContext, useFieldArray } from 'clayco-controls';
import Moment from 'moment';
import { Table } from 'react-bootstrap';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons'; 

const Certificates = ({ yesMatchedAssociates, showLoading, authorizationCode }) => {
    const {t} = useTranslation();
    const {instance, accounts} = useMsal();
    const { control } = useFormContext();
    const { fields, remove, append } = useFieldArray({
        control,
        keyName: "key",
        name: 'certification'
    })
    const _api = new ApiProvider(instance, accounts[0]);

    const [expandHistory, setExpandHistory] = useState(true);
    const [certifications, setCertifications] = useState([]);
    const [certificationHistory, setCertificationHistory] = useState([]);

    useEffect(()=>{
        const loadCertificateFields = async () =>{

            showLoading(true);
            const response = await _api.Get("certification/get");
            showLoading(false);
            if (response != null && !response.error)
            {
                const activeCertifications = response.filter(x => x.isActive === true);
                setCertifications(activeCertifications);
                remove();
                for(let i = 0; i < activeCertifications.length; i++){
                    append(activeCertifications[i]);
                }
            }
        };

        loadCertificateFields();
    }, [window.language]);

    useEffect(()=>{
    
        const loadCertificationHistory = async () =>{
    
            if (yesMatchedAssociates == null) {
                setCertificationHistory([]);
                return;
            }

            showLoading(true);

            var associateCertifications = [];
            for (var i=0; i< yesMatchedAssociates.length; i++) {
                const certificates = await _api.Get(`certification/getbyassociateid/${yesMatchedAssociates[i].associate?.id}/${authorizationCode}`);
                if (certificates.error != null){
                    console.error(certificates.error);
                    return;
                }
                associateCertifications = associateCertifications.concat(certificates);
            }
            
            showLoading(false);

            
            setCertificationHistory(associateCertifications.map((certification) => {
        
                const expMoment = Moment(certification.expirationDate);
                const expiration = certification.expirationDate == null ? null : expMoment.format('MM/DD/YYYY');
                const expirationFormatted = certification.expirationDate == null ? null : expMoment.format('YYYY-MM-DD');
                const expirationDate = expMoment.toDate();
                const invalidated = certification.invalidatedOn != null;
        
                // get for language
                const matchingCert = certifications.find(f => f.id === certification.certificationId);

                return {
                id: certification.id,
                name: matchingCert?.name,
                expiration: expiration,
                expirationFormatted: expirationFormatted,
                expirationDate: expirationDate,
                invalidated: invalidated,
                hasFile: certification.file != null && certification.file !== '',
                selectedCertification: certifications?.find(option => option.id === certification.certificationId ),
                };
            }));
        
          
        };
    
        loadCertificationHistory();
    
    }, [yesMatchedAssociates, authorizationCode, window.language, certifications]);
      
    return(
        <>
        <div className='card p-0 my-3'>
            <h6 className="card-header">
                {t('Training Certificates')}
            </h6>
                
            {certificationHistory?.length > 0 && (
            
                <div className='card p-0 m-3'>

                    <h6 className="card-header text-start">
                        {t('Certificates On File')}
                        { expandHistory 
                            ? <ChevronDown className='float-end' onClick={() => setExpandHistory(false)}/> 
                            : <ChevronUp className='float-end' onClick={() => setExpandHistory(true)}/> 
                        }
                    </h6>
                    <Collapse in={expandHistory}>
                    <div>
                        <div className='card-body'>
                        
                            <Table borderless striped responsive style={{ tableLayout: 'fixed' }}>
                                <thead>
                                <tr>
                                    <th style={{ backgroundColor: 'lightGray' }}>{t('Certification')}</th>
                                    <th style={{ backgroundColor: 'lightGray' }}>{t('Expiration Date')}</th>
                                </tr>
                                </thead>
                                <tbody>
                    
                                {certificationHistory?.map((certification, i) => (
                    
                                    (!certification.invalidated) && (
                                    <tr key={`cert-tr-${i}`}>
                                    <td key={`name-tr-${i}-td-3`}style={{ textAlign: 'left' }}>
                                        {certification.name}
                                    </td>
                                    <td key={`expd-tr-${i}-td-4`}style={{ textAlign: 'left' }}>
                                        { certification.expiration}
                                    </td>
                    
                                    </tr>
                                    )
                                ))}
                    
                                </tbody>
                            </Table>
                            
                        </div>
                    
                    </div>
                    </Collapse>
                </div>
            )}


            <div className='card-body'>
                <div className='card-subtitle mb-2 text-muted fst-italic'>
                    {t('CertificationTextKey')}
                </div>
                <ul className='list-group list-group-flush'>
                    {
                        certifications ?
                        fields.map((field, index)=>{
                            console.log(field);
                        return ( 
                            <CertificateField key={field.id} certification={certifications[index]} index={index} allowNameEdit={field.id === 29} /> )
                        }) 
                        : <></>
                    }
                </ul>
            </div>
        </div>
        </>
    );
}

export default Certificates;